import { type NLPSearchType } from '../../../ai-answer-dialog/types';

export enum EditedDefinitionScope {
	SPACE = 'SPACE',
	PAGE = 'PAGE',
	BLOGPOST = 'BLOGPOST',
	ORGANIZATION = 'ORGANIZATION',
	PROJECT = 'PROJECT',
}

export type CreateDefinitionFunctionArgs = {
	keyPhrase: string;
	editedDefinition: string;
	scope: EditedDefinitionScope;
	referenceContentId: string | null;
	referenceUrl: string | null;
};

export type CreateDefinitionFunctionType = ({
	keyPhrase,
	editedDefinition,
	scope,
	referenceContentId,
	referenceUrl,
}: CreateDefinitionFunctionArgs) => Promise<NLPSearchType>;

export type CuratedDefinitionSourceType = {
	id: string;
	type: string;
	title: string;
	container: string;
	iconUrl: string;
	url: string;
	lastModified?: string;
};

export type CuratedDefinitionSearchSourcesFunctionType = (
	query: string,
) => Promise<CuratedDefinitionSourceType[]>;

export type RestrictionOptionType = {
	label: string;
	value: EditedDefinitionScope;
	icon: React.ReactNode;
};

export type ConfluenceScopeType = {
	contentARI: string;
	spaceARI: string;
};

export type JiraScopeType = {
	projectARI: string;
};

export type CuratedDefinitionScopeConfigType = {
	workspaceId: string;
	definitionRestrictionOptions: RestrictionOptionType[];
	productScopes: ConfluenceScopeType | JiraScopeType;
};

export type CuratedDefinitionOptions = {
	curatedDefinitionScopeConfig: CuratedDefinitionScopeConfigType;
	editModalShownRef?: React.MutableRefObject<boolean>;
	// deprecated
	showHistoryModal?: () => void;
};

export type ObjectResolverParamType = {
	resourceUrl: string;
};

export type ObjectResolverDataType = {
	body: Body;
	status: number;
};

export type Body = {
	meta: Meta;
	data: Data;
};

export type Data = {
	'@context': Context;
	generator: Generator;
	'@type': string[];
	url: string;
	name: string;
	'atlassian:state': string;
	summary: string;
	updated: Date;
	'schema:dateCreated': Date;
	attributedTo: AtlassianOwnedBy;
	'schema:commentCount': number;
	'atlassian:reactCount': number;
	'atlassian:titlePrefix': AtlassianTitlePrefix;
	'atlassian:ownedBy': AtlassianOwnedBy;
	'atlassian:ari': string;
	preview: Preview;
};

export type Context = {
	'@vocab': string;
	atlassian: string;
	schema: string;
};

export type AtlassianOwnedBy = {
	'@type': string;
	name: string;
	icon: string;
};

export type AtlassianTitlePrefix = {
	text: string;
	'@type': string;
};

export type Generator = {
	'@type': string;
	'@id': string;
	name: string;
	icon: Icon;
};

export type Icon = {
	'@type': string;
	url: string;
};

export type Preview = {
	'@type': string;
	href: string;
	'atlassian:supportedPlatforms': string[];
};

export type Meta = {
	auth: any[];
	definitionId: string;
	product: string;
	visibility: string;
	access: string;
	resourceType: string;
	objectId: string;
	tenantId: string;
	activationId: string;
	containerId: string;
	category: string;
	supportedFeature: string[];
	key: string;
};
